import { render, staticRenderFns } from "./DefaultTableVersion.vue?vue&type=template&id=46b96516"
import script from "./DefaultTableVersion.vue?vue&type=script&lang=ts"
export * from "./DefaultTableVersion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports